<div class="modal-heading modal-heading-1 py-3 d-flex flex-row">
  <div class="label_name flex-grow-1">
    <h3 class="m-kh-1">{{ 'EXPLORE_ACTIVITIES_PICK_CLASS_MODAL.EXPLORE_ACTIVITIES' | translate }}</h3>
  </div>
  <div class="label_name">
    <fa-icon [icon]="['fas', 'times']" (click)="closeModal()"></fa-icon>
  </div>
</div>
<div class="modal-body modal-body-padding d-flex flex-column">
  <div class="color-black body-title-text text-center my-kh-4">{{ 'EXPLORE_ACTIVITIES_PICK_CLASS_MODAL.SELECT_ONE_OF_YOUR_EXISTING' | translate }}</div>
  <button class="btn btn-white explore-activities-class" *ngFor="let classInfo of classes" (click)="selectClass(classInfo)" [class.selected]="classInfo.ClassId === selectedClass?.ClassId">
    <div class="d-flex align-content-center">
      <span class="flex-grow-1 left"><b>{{ 'EXPLORE_ACTIVITIES_PICK_CLASS_MODAL.CLASS_ITEM_ORDER' | translate:{ itemOrder: classInfo.ItemOrder } }}</b> - {{classInfo.Name}}</span>
      <fa-icon [icon]="['fas', 'user']" class="mx-kh-2 grey btn-line-height"></fa-icon>
      <span class="grey">{{classInfo.NumStudents}}</span>
    </div>
  </button>
  <div *ngIf="isError" class="text-center">
    <span class="d-block text-danger spacer-md">{{ 'EXPLORE_ACTIVITIES_PICK_CLASS_MODAL.PLEASE_SELECT_A_CLASS' | translate }}</span>
  </div>
  <div class="d-flex justify-content-center">
    <button class="explore-activities-button bg-blue-main medium-title-text border-radius-base mt-kh-1" (click)="startExploring()" data-testid="start-exploring-button">
      <span>{{ 'EXPLORE_ACTIVITIES_PICK_CLASS_MODAL.START_EXPLORING' | translate }}</span>
    </button>
  </div>
</div>